
import { useState } from 'react';

export default function EventBanner() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const events = [
    {
      title: '신규 회원 특별 혜택',
      subtitle: '첫 예약 시 최대 30,000원 적립금',
      image: 'https://public.readdy.ai/ai/img_res/85f9107a0ff8d8b521c01a98bda5aa65.jpg',
      bgColor: 'from-rose-50 to-pink-50'
    },
    {
      title: '봄맞이 스페셜 프로모션',
      subtitle: '네일·속눈썹 패키지 예약 시 10,000원 적립금',
      image: 'https://readdy.ai/api/search-image?query=Spring%20beauty%20promotion%20banner%20with%20cherry%20blossom%20pink%20tones%2C%20elegant%20floral%20elements%2C%20soft%20pastel%20gradient%20background%2C%20luxury%20nail%20art%20and%20eyelash%20extension%20imagery%2C%20sophisticated%20feminine%20design%2C%20premium%20beauty%20package%20display%2C%20warm%20spring%20atmosphere&width=1200&height=500&seq=event-banner-2&orientation=landscape',
      bgColor: 'from-pink-50 to-purple-50'
    },
    {
      title: '친구 초대 이벤트',
      subtitle: '친구와 함께 5,000원 적립금 받기',
      image: 'https://readdy.ai/api/search-image?query=Referral%20program%20banner%20with%20two%20elegant%20women%20enjoying%20beauty%20services%20together%2C%20soft%20pastel%20pink%20and%20beige%20tones%2C%20friendly%20atmosphere%2C%20modern%20minimalist%20design%2C%20luxury%20beauty%20salon%20setting%2C%20sophisticated%20promotional%20layout%2C%20warm%20inviting%20ambiance&width=1200&height=500&seq=event-banner-3&orientation=landscape',
      bgColor: 'from-purple-50 to-rose-50'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % events.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + events.length) % events.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="py-16 px-6 bg-gradient-to-b from-white to-pink-50/20">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl shadow-xl">
          {/* Slides */}
          <div className="relative h-[400px]">
            {events.map((event, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-all duration-700 ${
                  index === currentSlide ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full'
                }`}
              >
                <div className={`relative w-full h-full bg-gradient-to-r ${event.bgColor}`}>
                  {/* Background Image */}
                  <div className="absolute inset-0">
                    <img
                      src={event.image}
                      alt={event.title}
                      className="w-full h-full object-cover object-top opacity-90"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/40 to-transparent"></div>
                  </div>

                  {/* Content */}
                  <div className="relative z-10 h-full flex items-center px-12 md:px-20">
                    <div className="max-w-2xl">
                      <div className="inline-block px-5 py-2 bg-white/95 backdrop-blur-sm rounded-full mb-8">
                        <span className="text-sm font-medium text-rose-400">Special Event</span>
                      </div>
                      
                      <h3 className="text-5xl md:text-6xl font-light text-white mb-6 leading-tight" style={{ fontFamily: 'Jua, sans-serif' }}>
                        {event.title}
                      </h3>
                      
                      <p className="text-2xl md:text-3xl text-white/95 font-light" style={{ fontFamily: 'Jua, sans-serif' }}>
                        {event.subtitle}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full hover:bg-white hover:scale-110 transition-all cursor-pointer shadow-lg"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-800"></i>
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full hover:bg-white hover:scale-110 transition-all cursor-pointer shadow-lg"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-800"></i>
          </button>

          {/* Indicators */}
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex space-x-3">
            {events.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentSlide
                    ? 'bg-white w-8'
                    : 'bg-white/50 hover:bg-white/75'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
